<template>
    <div>
        <div class="flex w-full mt-3 pb-3 border-b border-a-brown-d7c7b8"
            @click="gotoCoupon()">
            <div class="font-bold ml-0 mr-auto text-a-brown-502314">{{lbl.shoppingcart.coupon_discount}}</div>
            <div class="mr-1 my-auto"  v-if="PlaceOrderStore.state.placeOrder.coupon">
                <img class="-mt-1" src="@/assets/shopping_cart/icon-coupon.svg" />
            </div>
            <div class="mr-1 my-auto cursor-pointer" v-if="PlaceOrderStore.state.placeOrder.coupon && PlaceOrderStore.state.placeOrder.coupon.name">
                <div class="text-14 text-a-red-d62300 campaign-name">{{PlaceOrderStore.state.placeOrder.coupon.name}}</div>
            </div>
            <div class="mr-1 my-auto cursor-pointer" v-if="PlaceOrderStore.state.placeOrder.coupon && !PlaceOrderStore.state.placeOrder.coupon.name">
                <div class="text-14 text-a-red-d62300 campaign-name">{{getPromoCodeText()}}</div>
            </div>
            <div class="mr-1 my-auto cursor-pointer" v-if="!PlaceOrderStore.state.placeOrder.coupon">
                <div class="text-14 text-a-red-d62300">{{lbl.shoppingcart.no_coupon}}</div>
            </div>
            <div class="mr-0 mb-1 mt-auto cursor-pointer">
                <img class="" src="@/assets/icon/ic-arrow-right-brown.svg" />
            </div>
        </div>
    </div>
</template>

<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "CartCoupon",
    inject: ['PlaceOrderStore'],
    mixins: [LocaleMixin],
    created: function() {
        console.log(this.PlaceOrderStore.state.placeOrder);
    },
    methods: {
        gotoCoupon: function () {
            if (this.PlaceOrderStore.state.placeOrder.coupon && !this.PlaceOrderStore.state.placeOrder.coupon.id) {
                this.PlaceOrderStore.state.placeOrder.coupon = null;
                this.PlaceOrderStore.methods.updatePlaceOrder();
            }
            this.tracking.event('shopping_bag','click_coupon_discount', null, null);
            this.$emit('gotoCoupon');
        },
        getPromoCodeText: function() {
            return `${this.lbl.coupon.discount} ${this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit} ${this.lbl.coupon.bath}`;
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/text.scss";

    .campaign-name {
        // width: auto;
        max-width: 150px;
        @extend %ellipsis-1;
    }
    
    
</style>